var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data_body"},[_c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_c('highcharts',{staticStyle:{"width":"95%","height":"95%"},attrs:{"options":_vm.option}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f4a39bb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dataBoardNew/school/courseNum/index.vue
// module id = null
// module chunks = 